import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dirtyTextPartsPayloadFlag']

  declare editorContainers: NodeListOf<Element>

  declare readonly dirtyTextPartsPayloadFlagTarget: HTMLInputElement
  declare readonly hasDirtyTextPartsPayloadFlagTarget: HTMLInputElement

  connect(): void {
    this.editorContainers = this.element.querySelectorAll(
      '.template-parts .sf-ace-editor'
    )

    if (this.hasDirtyTextPartsPayloadFlagTarget) {
      this.dirtyTextPartsPayloadFlagTarget.value = 'true'
    }
  }

  submit(): void {
    this.editorContainers.forEach((wrapper) => {
      const textArea = wrapper.querySelector(
        'textarea.page-input'
      ) as HTMLTextAreaElement
      const aceTextArea = wrapper.querySelector(
        'textarea.ace_text-input'
      ) as HTMLTextAreaElement

      const dirty = textArea.value !== textArea.defaultValue
      if (!dirty) {
        // Disabling these text areas will prevent them from being submitted to
        // the server. Also, the page reloads after submission, so we don't need
        // to worry about re-enabling them after submission completes.
        textArea.disabled = true
        aceTextArea.disabled = true
      }
    })
  }
}
